import React from 'react';

import Typography from '@/ui-components/Typography';

import useBem from '@/use/useBem';

const sparksIcon = {
  '1x': require('@/assets/images/icons/sparks.png?size=32'),
  '2x': require('@/assets/images/icons/sparks.png?size=64'),
};

export type SparksBadgeProps = {
  amount: number;
  compact?: boolean;
};

const SparksBadge: React.FC<SparksBadgeProps> = ({ amount, compact = false }) => {
  const { bem } = useBem('sparks-badge');

  return (
    <div className={bem('', { compact })} title="Sparks">
      <div className={bem('box')}>
        <img
          src={sparksIcon['1x']}
          srcSet={`${sparksIcon['2x']} 2x`}
          alt=""
          className={bem('icon')}
        />
      </div>
      <Typography variant="s" component="div" className={bem('amount')}>
        {amount}
      </Typography>
    </div>
  );
};

export default SparksBadge;
